import { Component } from "@angular/core";

@Component({
  selector: "aa-selfserv-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: false,
})
export class AppComponent {
  title = "selfserv";
}
